export default {
  RESERVATIONS_AMOUNT_LOADING: '@RESERVATIONS_AMOUNT_LOADING',
  RESERVATIONS_AMOUNT_SUCCESS: '@RESERVATIONS_AMOUNT_SUCCESS',
  RESERVATIONS_AMOUNT_ERROR: '@RESERVATIONS_AMOUNT_ERROR',

  GET_RESERVATIONS_ITEMS_LOADING: '@RESERVATIONS_GET_RESERVATIONS_ITEMS_LOADING',
  GET_RESERVATIONS_ITEMS_SUCCESS: '@RESERVATIONS_GET_RESERVATIONS_ITEMS_SUCCESS',
  GET_RESERVATIONS_ITEMS_ERROR: '@RESERVATIONS_GET_RESERVATIONS_ITEMS_ERROR',
  CLEAR_RESERVATIONS_ITEMS: '@RESERVATIONS_CLEAR_RESERVATIONS_ITEMS',

  SEARCH_PRODUCT_FOR_RESERVATIONS_LOADING: '@RESERVATIONS_SEARCH_PRODUCT_FOR_RESERVATIONS_LOADING',
  SEARCH_PRODUCT_FOR_RESERVATIONS_SUCCESS: '@RESERVATIONS_SEARCH_PRODUCT_FOR_RESERVATIONS_SUCCESS',
  SEARCH_PRODUCT_FOR_RESERVATIONS_ERROR: '@RESERVATIONS_SEARCH_PRODUCT_FOR_RESERVATIONS_ERROR',

  CLEAR_RESERVATIONS_CART: '@RESERVATIONS_CLEAR_RESERVATIONS_CART',

  ADD_RESERVATIONS_ITEM_QTY: '@RESERVATIONS_ADD_RESERVATIONS_ITEM_QTY',
  REMOVE_RESERVATIONS_ITEM_QTY: '@RESERVATIONS_REMOVE_RESERVATIONS_ITEM_QTY',
  REMOVE_RESERVATIONS_CART_ITEM: '@RESERVATIONS_REMOVE_RESERVATIONS_CART_ITEM',

  RESERVATIONS_STORE_DETAILS_LOADING: '@RESERVATIONS_STORE_DETAILS_LOADING',
  RESERVATIONS_STORE_DETAILS_SUCCESS: '@RESERVATIONS_STORE_DETAILS_SUCCESS',
  RESERVATIONS_STORE_DETAILS_ERROR: '@RESERVATIONS_CSTORE_DETAILS_ERROR',

  SET_RESERVATIONS_PROFILE_DATA: '@RESERVATIONS_SET_RESERVATIONS_PROFILE_DATA',
  CLEAR_RESERVATIONS_PROFILE_DATA: '@RESERVATIONS_CLEAR_RESERVATIONS_PROFILE_DATA',

  GET_STORE_INFORMATION_LOADING: '@RESERVATIONS_GET_STORE_INFORMATION_LOADING',
  GET_STORE_INFORMATION_SUCCESS: '@RESERVATIONS_GET_STORE_INFORMATION_SUCCESS',
  GET_STORE_INFORMATION_ERROR: '@RESERVATIONS_GET_STORE_INFORMATION_ERROR',

  SUBMIT_RESERVATION_ORDER_LOADING: '@RESERVATIONS_SUBMIT_RESERVATION_ORDER_LOADING',
  SUBMIT_RESERVATION_ORDER_SUCCESS: '@RESERVATIONS_SUBMIT_RESERVATION_ORDER_SUCCESS',
  SUBMIT_RESERVATION_ORDER_ERROR: '@RESERVATIONS_SUBMIT_RESERVATION_ORDER_ERROR',

  RESERVATIONS_SEARCH_LOADING: '@RESERVATIONS_SEARCH_LOADING',
  RESERVATIONS_SEARCH_SUCCESS: '@RESERVATIONS_SEARCH_SUCCESS',
  RESERVATIONS_SEARCH_ERROR: '@RESERVATIONS_SEARCH_ERROR',
  RESERVATIONS_SEARCH_CLEAR: '@RESERVATIONS_SEARCH_CLEAR',

  RESERVATION_DETAILS_LOADING: '@RESERVATION_DETAILS_LOADING',
  RESERVATION_DETAILS_SUCCESS: '@RESERVATION_DETAILS_SUCCESS',
  RESERVATION_DETAILS_ERROR: '@RESERVATION_DETAILS_ERROR',
  RESERVATION_DETAILS_CLEAR: '@RESERVATION_DETAILS_CLEAR',

  RESERVATION_STORE_DETAILS_SUCCESS: '@RESERVATION_STORE_DETAILS_SUCCESS',
  RESERVATION_STORE_DETAILS_ERROR: '@RESERVATION_STORE_DETAILS_ERROR',
  RESERVATION_STORE_DETAILS_LOADING: '@RESERVATION_STORE_DETAILS_LOADING',
  RESERVATION_EMAIL_TEMPLATE_LOADING: '@RESERVATION_EMAIL_TEMPLATE_LOADING',
  RESERVATION_EMAIL_TEMPLATE_SUCCESS: '@RESERVATION_EMAIL_TEMPLATE_SUCCESS',
  RESERVATION_EMAIL_TEMPLATE_ERROR: '@RESERVATION_EMAIL_TEMPLATE_ERROR',
  RESERVATION_CLEAR_EMAIL_TEMPLATE: '@RESERVATION_CLEAR_EMAIL_TEMPLATE',

  RESERVATIONS_MANAGER_METRICS_LOADING: '@RESERVATIONS_MANAGER_METRICS_LOADING',
  RESERVATIONS_MANAGER_METRICS_SUCCESS: '@RESERVATIONS_MANAGER_METRICS_SUCCESS',
  RESERVATIONS_MANAGER_METRICS_ERROR: '@RESERVATIONS_MANAGER_METRICS_ERROR',

  RESERVATIONS_ITEMS_LOADING: '@RESERVATIONS_ITEMS_LOADING',
  RESERVATIONS_ITEMS_SUCCESS: '@RESERVATIONS_ITEMS_SUCCESS',
  RESERVATIONS_ITEMS_ERROR: '@RESERVATIONS_ITEMS_ERROR',

  RESERVATIONS_STORE_CLEAR: '@RESERVATIONS_STORE_CLEAR',
  SELECT_ASSOCIATE_RESERVATIONS: '@SELECT_ASSOCIATE_RESERVATIONS',
  RESERVATIONS_STORE_FILTERS: '@RESERVATIONS_STORE_FILTERS',
  RESERVATIONS_STORE_RESET_FILTERS: '@RESERVATIONS_STORE_RESET_FILTERS',

  RESERVATIONS_ADVANCED_SEARCH_LOADING: '@RESERVATIONS_ADVANCED_SEARCH_LOADING',
  RESERVATIONS_ADVANCED_SEARCH_SUCCESS: '@RESERVATIONS_ADVANCED_SEARCH_SUCCESS',
  RESERVATIONS_ADVANCED_SEARCH_ERROR: '@RESERVATIONS_ADVANCED_SEARCH_ERROR',
  RESET_ADVANCED_SEARCH_RESERVATIONS: '@RESET_ADVANCED_SEARCH_RESERVATIONS',
};
